import React, { useState } from 'react'
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";
import { Link } from 'react-router-dom';

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

const models = [

  { name: "DAISY", image: "/images/daisy22.jpg", description: "Versatile and functional display units with all the options for food retail and foodservice.",slug: "daisy-upper", },
  { name: "FUTURO 2", image: "images/futuro22.jpg", description: "The most complete and flexible self-service solution.",slug: "FUTURO2-upper", },
  { name: "Vista Grab & Go", image: "images/vistagrabgo.jpg", description: "Chilled compact display units with large capacity.",slug:"vista-grab-and-go" },
  // { name: "Futuro 2 vertical ", image: "images/neweline.jpg", description: "Compact vertical displays for modern retail." },
  { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Multi-deck model offering a space-saving solution for high-demand environments in butchery.", slug: "Futuro-2" },
  { name: "Futuro Combi", image: "images/newfuturo.png", description: "Total versatility combines serve-over and self-service.",slug: "FuturoCombi-lower", },
  { name: "Victory", image: "images/VICTORY1.png", description: "The right choice for grab’n’go sales and.",slug:"Victory" },
  { name: "Fresco Combi", image: "images/fresco.jpg", description: "Assisted service and self-service, all-in-one display.",slug: "FrescoCombi-lower", },
];

function Semivertical() {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(models.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedModels = models.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="w-full font-thin mb-20">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/semilanding.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></section>

      {/* Models Display */}
      <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Semi-Verticals</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Our Semi-Verticals and Grab & Go are available for preservation of drinks and food in a chilled or heated environment. You can choose models with rear doors for an easier product replacement.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase mt-6">Typologies</Link>
        </div>
      </section>

      {/* Products Grid */}
       <section className="px-2 lg:px-32">
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
                {selectedModels.map((model, index) => (
                  <div key={index} className="text-center">
         <Link to={`/${encodeURIComponent((model.slug || "").replace(/\s+/g, "-").replace(/&/g, "and"))}`}>
                      <div
                        className="relative w-full h-80 md:mb-4"
                        style={{
                          backgroundImage: `url(${model.image})`,
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          height: "300px",
                        }}
                      ></div>
                      <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
                      <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
                    </Link>
      
                    {/* Small icons under each model */}
                    <div className="flex justify-center gap-4 mt-4">
                      {icons.map((icon, i) => (
                        <div key={i} className="text-2xl text-gray-500 cursor-pointer hover:text-black transition">
                          {icon.icon}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
      {/* <section className="px-2 lg:px-32">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
          {selectedModels.map((model, index) => (
            <div key={index} className="text-center">
              <Link to={`/semiverticalsproduct/${model.name}`}>
                <div
                  className="relative w-full h-80 md:mb-4"
                  style={{
                    backgroundImage: `url(${model.image})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "300px",
                  }}
                ></div>
                <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
                <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
              </Link>

            
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl text-gray-500">{icon.icon}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-10 space-x-4">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-md ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
        >
          Previous
        </button>

        <span className="text-xl font-semibold">{currentPage} - {totalPages}</span>

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-md ${currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Semivertical
// import React, { useEffect, useState } from 'react';
// import { motion } from 'framer-motion';
// import { semiverticalBannerGetdata, semiverticalProductsGet } from '../Apihandlling';
// import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const icons = [
//   { name: 'Coffee Shop', icon: <FaCoffee className="text-xl text-gray-700" /> },
//   { name: 'Bakery & Pastry', icon: <FaBreadSlice className="text-xl text-gray-700" /> },
//   { name: 'Fish & Seafood', icon: <FaFish className="text-xl text-gray-700" /> },
//   { name: 'Supermarket', icon: <FaStore className="text-xl text-gray-700" /> },
//   { name: 'Restaurant', icon: <FaUtensils className="text-xl text-gray-700" /> },
//   { name: 'Ice Cream', icon: <FaIceCream className="text-xl text-gray-700" /> },
//   { name: 'Chocolate', icon: <FaCookieBite className="text-xl text-gray-700" /> },
// ];

// function Semivertical() {
//   const [bannerData, setBannerData] = useState([]);
//   const [modelData, setModelData] = useState([]);

//   useEffect(() => {
//     semiverticalBannerGetdata()
//       .then((data) => setBannerData(data))
//       .catch((err) => console.error('Banner Fetch Error:', err));
//   }, []);

//   useEffect(() => {
//     semiverticalProductsGet()
//       .then((data) => {
//         console.log('Product Data:', data); // Debugging log
//         setModelData(data);
//       })
//       .catch((err) => console.error('Products Fetch Error:', err));
//   }, []);

//   return (
//     <div className="font-playfair">
//       {/* Banner Section */}
//       {bannerData.length > 0 ? (
//         <section className="relative w-full h-[500px] md:h-screen">
//           <img
//             src={bannerData[0].landingimage || ''}
//             alt="Banner"
//             className="absolute inset-0 w-full h-full object-cover"
//           />
//           {/* <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 sm:px-10 bg-black/50">
//             <h1 className="text-4xl sm:text-6xl font-bold uppercase text-white">
//               {bannerData[0].landingtext || 'Landing Text'}
//             </h1>
//             <p className="text-lg sm:text-xl text-white max-w-3xl mt-2">
//               {bannerData[0].landingdescription || 'Landing Description'}
//             </p>
//           </div> */}
//         </section>
//       ) : (
//         <section className="h-screen flex items-center justify-center bg-gray-200">
//           <motion.div
//             className="p-6 text-center"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1, ease: 'easeInOut' }}
//           >
//             <h1 className="text-4xl md:text-6xl font-bold text-gray-800 animate-pulse">
//               Loading...
//             </h1>
//           </motion.div>
//         </section>
//       )}

//       {/* Semivertical Products */}
//       {/* <div className="text-center">
//         <Link to="/" className="block py-1 pl-4 hover:underline text-blue-400 mt-12">
//           Home-Display
//         </Link>
//       </div> */}

//       <section className="py-16 bg-white text-center px-6 sm:px-10">
//         {/* <h2 className="text-3xl sm:text-5xl font-bold text-gray-800 mb-10">Semivertical Models</h2> */}
//         <div className="container mx-auto max-w-6xl">
//           <div className=" flex flex-col items-center justify-center text-center px-6 mt-12">
//                 <h1 className="text-4xl sm:text-6xl font-bold uppercase text-black">
//             {bannerData?.[0]?.landingtext || "Landing Text"}
//           </h1>
//           <p className="text-lg sm:text-xl text-black max-w-3xl mt-2">
//             {bannerData?.[0]?.landingdescription || "Landing Description"}
//           </p>
          
//                     <div className=" flex justify-center">
//                   <Link to="/" className="block py-1 pl-4 hover:underline text-blue-400 mt-6">Home -</Link>
//                           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline  mt-6">Models -</Link>
                  
//                   <button to="" className=" py-1 pl-4  mt-6">Display</button>
//           </div>
//                 </div>
//           {modelData.length > 0 ? (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
//               {modelData.map((item, index) => (
//                 <div key={item._id} className="text-center flex flex-col items-center">
//                   <Link to={`/semiverticals/${item._id}`} className="block">
//                     <img
//                       src={item.image}
//                       alt={item.text}
//                       className="w-full max-w-xs h-64 object-cover rounded-md"
//                     />
//                   </Link>
//                   <h3 className="text-xl font-semibold text-gray-800 mt-4">{item.text}</h3>
//                   <p className="text-gray-600 mt-2 text-sm leading-relaxed max-w-md">
//                     {item.textdescription}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-xl text-gray-500">No model data available</p>
//           )}
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Semivertical;
